const CF_ZONE = 'https://farescraper.com'

export default function cfImage (url, width, { quality = 75, format = 'auto' } = {}) {
  if (!url) return url
  const opts = [`width=${width}`, `quality=${quality}`, `format=${format}`].join(',')
  return `${CF_ZONE}/cdn-cgi/image/${opts}/${url}`
}
